import React, { useContext, useRef } from 'react';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';
import ExchangeDifferenceGrid from './ExchangeDifferenceGrid';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles } from '@material-ui/core';
import { commonFilter } from '../../constants/StyleConstants';
import useExchangeDifferencePresenter from './ExchangeDifferencePresenter';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import CustomDatePicker from '../../components/UI/CustomDatePicker';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { isSupplier } = useContext(LoginContext);
  const { selectedSupplier, setSelectedSupplier, dateFrom, setDateFrom, dateTo, setDateTo, validateAndSearch, cleanFilters } = filtersProps;

  return (
    <div className={classes.filters}>
      {!isSupplier && <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />}
      <CustomDatePicker value={dateFrom} maxDate={dateTo} label="Fecha desde" setValue={setDateFrom} />
      <CustomDatePicker value={dateTo} minDate={dateFrom} label="Fecha hasta" setValue={setDateTo} />
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const ExchangeDifference = () => {
  const tableRef = useRef();
  const { isSupplier } = useContext(LoginContext);
  const { firstLoad, rows, loading, ...filtersProps } = useExchangeDifferencePresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
        <ExchangeDifferenceGrid data={rows} tableRef={tableRef} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};

export default ExchangeDifference;
